import React from 'react';
import { ShoppingBag } from 'lucide-react';
import { useCart } from '@/context/CartContext';
import { TID } from '@/constants/testIds';

const links = [
  { key: 'soaps', label: 'Soaps', href: '#soaps' },
  { key: 'chocolates', label: 'Chocolates', href: '#chocolates' },
  { key: 'hampers', label: 'Hampers', href: '#hampers' },
  { key: 'story', label: 'Our Story', href: '#story' },
  { key: 'contact', label: 'Contact', href: '#contact' },
];

export const Header = () => {
  const { itemCount, openCart } = useCart();

  return (
    <header className="cw-header" data-testid={TID.header}>
      <div className="cw-container flex items-center justify-between h-20">
        <a href="#top" className="flex items-center gap-2" data-testid={TID.navLogo}>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-full bg-[var(--cw-blue)] flex items-center justify-center">
              <span className="font-heading text-sm font-semibold text-[var(--cw-text)]">C</span>
            </div>
            <div className="leading-none">
              <div className="font-heading text-base font-semibold tracking-tight">
                CHOCO<span className="text-[var(--cw-blue-hover)]">-</span>WASH
              </div>
              <div className="text-[10px] tracking-[0.25em] uppercase text-[var(--cw-muted)]">
                Soap &amp; Chocolate
              </div>
            </div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <a
              key={l.key}
              href={l.href}
              className="cw-btn-ghost text-sm"
              data-testid={TID.navLink(l.key)}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <button
          type="button"
          onClick={openCart}
          className="relative cw-btn-ghost inline-flex items-center gap-2"
          data-testid={TID.cartButton}
          aria-label="Open cart"
        >
          <ShoppingBag className="w-5 h-5" />
          <span className="hidden sm:inline text-sm">Cart</span>
          {itemCount > 0 && (
            <span
              className="absolute -top-1 -right-1 min-w-[20px] h-5 px-1.5 rounded-full bg-[var(--cw-yellow)] text-[11px] font-semibold flex items-center justify-center text-[var(--cw-text)]"
              data-testid={TID.cartBadge}
            >
              {itemCount}
            </span>
          )}
        </button>
      </div>
    </header>
  );
};
